import React from 'react'
import { Route, Routes } from 'react-router-dom'
import {Home} from  "./pages/adminHome"
import {ContentManagement} from "./pages/adminContentManagement"
import {ModerationDashboard} from "./pages/adminModerationDashboard"
import ModerationLogs from './pages/adminModerationLogs'


export const Dashroutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/adminContentManagement" element={<ContentManagement/>} />
       <Route path="/adminModerationDashboard" element={<ModerationDashboard/>} />
       <Route path="/adminModerationLogs" element={<ModerationLogs/>} />
    </Routes>
  )
}
